<table mat-table [dataSource]="rowIndices" class="mat-table">

    <ng-container matColumnDef="indexColumn">
        <th mat-header-cell *matHeaderCellDef>Data Input</th>
        <td mat-cell *matCellDef="let rowIndex">
            {{ rowIndex + 1 }}
        </td>
    </ng-container>

    <ng-container
            *ngFor="let insp of previousInspections; let colIndex = index"
            [matColumnDef]="'past-' + colIndex"
    >
        <th mat-header-cell *matHeaderCellDef>
            {{ insp.inspectionDate | localeDate:'mediumDate' }}
        </th>
        <td mat-cell *matCellDef="let rowIndex">
            <ng-container *ngIf="getPastValue(colIndex, rowIndex) as val; else empty">
                {{ val }}
            </ng-container>
            <ng-template #empty>—</ng-template>
        </td>
    </ng-container>

    <ng-container matColumnDef="current">
        <th mat-header-cell *matHeaderCellDef> {{ currentInspection?.inspectionDate  | localeDate:'mediumDate' }}</th>
        <td mat-cell *matCellDef="let rowIndex">
            <div class="value-box"
                 [ngClass]="{
       'over-threshold': isOverThreshold(rowIndex),
       'under-threshold': !isOverThreshold(rowIndex),
       'has-error': getCurrentControl(rowIndex).invalid && getCurrentControl(rowIndex).touched
     }">
                <input
                        matInput
                        type="number"
                        [formControl]="getCurrentControl(rowIndex)"
                />

                <ng-container *ngIf="isOverThreshold(rowIndex)">
                    <app-custom-popover [index]="rowIndex" title="pages.inspectionTable.thkAlertTitle"
                                        [content]="'pages.inspectionTable.thkAlertDescription' | translate"
                                        [tooltip]="'pages.inspectionTable.thkAlertTitle'">
                    </app-custom-popover>
                </ng-container>
            </div>

        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let rowIndex; columns: columns"></tr>
</table>

<div class="add-row-container">
    <button mat-raised-button color="secondary" class="w-100" (click)="onAddRow()">
        {{ 'pages.inspectionTable.addAnotherValue' | translate }}
    </button>
</div>
